import axios from 'axios';
import { API_CONFIG, STORAGE_KEYS } from '../../constants';
import {
  GetSegmentChangeHistoryRequestPayload,
  GetSegmentChangeHistoryResponse,
} from 'types/segments/segments.types';
import { GetContactActivityResponse } from 'types/contacts/contacts.types';

const SERVER_URL = API_CONFIG.SERVER_URL;

// Create axios instance with default config
const api = axios.create({
  baseURL: SERVER_URL,
});

// Add request interceptor to include token in headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid, redirect to login
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
      localStorage.removeItem(STORAGE_KEYS.USER);
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export const getSegmentChangeHistory = async (
  payload: GetSegmentChangeHistoryRequestPayload
): Promise<GetSegmentChangeHistoryResponse> => {
  try {
    const { segmentId, startDate, endDate, page, limit, changeType } = payload;
    const params = new URLSearchParams();

    params.append('startDate', startDate);
    params.append('endDate', endDate);

    if (page !== undefined) params.append('page', page.toString());
    if (limit !== undefined) params.append('limit', limit.toString());
    if (changeType) params.append('changeType', changeType);

    const response = await api.get(
      `/segment-change-history/${segmentId}?${params}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching segment change history:', error);
    throw error;
  }
};

export const getContactActivity = async (
  contactId: string
): Promise<GetContactActivityResponse> => {
  try {
    const response = await api.get(
      `/segment-change-history/contact/${contactId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching contact activity:', error);
    throw error;
  }
};
